import { get } from 'lodash';
import { mapGetters } from 'vuex'

const CompanyRoles = {
  computed: {
    ...mapGetters('currentuser', ['currentUser']),
  },
  methods: {
    //return object with all the roles for the employee in each department
    //ret = {instructor_deps: [{name: Norr, id: 1}, {name: Syd, id: 2}], departmentAdministrator_deps: [{name: Syd, id: 2}]}
    getEmployeeRoles(employee) { 
      let ret = {
        instructor_deps: [], 
        departmentAdministrator_deps: [], 
        companyEducationResponsible_deps: [], 
        distanceEducationAdministrator_deps: []
      }         
      if (employee.departmentEmployments) {                      
        employee.departmentEmployments.forEach(o => {
          if (o.isDepartmentInstructor == true) {
            ret.instructor_deps.push({ name: o.department.name, id: o.departmentId });
          }
          if (o.isDepartmentEducationResponsible) {
            ret.companyEducationResponsible_deps.push({
              name: o.department.name,
              id: o.departmentId,
            });
          }
          if (o.isDepartmentDistanceEducationAdministrator) {
            ret.distanceEducationAdministrator_deps.push({
              name: o.department.name,
              id: o.departmentId,
            });
          }
          if (o.isDepartmentAdministrator) {
            ret.departmentAdministrator_deps.push({
              name: o.department.name,
              id: o.departmentId,
            });
          }
        });
        return ret
      }     
    },
    getDepartments(emp, inRole='') {
      let departments = []
      if (!emp.departmentEmployments)
        return ''
      emp.departmentEmployments.forEach(de => {
        if (inRole=='') {
          departments.push(de.department.name)
        }
        else if (inRole=='isDepartmentAdministrator' && de.isDepartmentAdministrator==true)
        {
          departments.push(de.department.name)
        }        
        else if (inRole=='isDepartmentDistanceEducationAdministrator' && de.isDepartmentDistanceEducationAdministrator==true)
        {
          departments.push(de.department.name)
        }        
        else if (inRole=='isDepartmentEducationResponsible' && de.isDepartmentEducationResponsible==true)
        {
          departments.push(de.department.name)
        }        
        else if (inRole=='isDepartmentInstructor' && de.isDepartmentInstructor==true)
        {
          departments.push(de.department.name)
        }        
      });
      return departments.join(', ')
    },
    getShortRoleDescriptionDepartment(emp, depId) {
      let roles = []
      if (emp.apprentice) roles.push('LÄR')
      if (emp.isAdministrator) {
        roles.push('FTGADM')
      }
      let dep = emp.departmentEmployments.find(x => x.id == depId)

      if (dep) {
        if (dep.isDepartmentInstructor) roles.push('HL')
        if (dep.isDepartmentEducationResponsible) roles.push('YUA')
        if (dep.isDepartmentDistanceEducationAdministrator) roles.push('BG')
        if (dep.isDepartmentAdministrator) roles.push('AVDADM')
      }

      return roles.join(', ')
    },
    getEmpSingleRole(emp, hasDep = false) {
      if (emp.apprentice) return 'isApprentice'
      if (emp.isAdministrator) {
        return 'isAdministrator'
      }

      if (emp.departmentEmployments && hasDep == true) {
        if (emp.departmentEmployments.length > 0) {
          if ((emp.departmentEmployments.findIndex(x => x.isDepartmentAdministrator)) > -1)
            return 'isDepartmentAdministrator'

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentEducationResponsible)) > -1)
            return 'isDepartmentEducationResponsible'

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentDistanceEducationAdministrator)) > -1)
            return 'isDepartmentDistanceEducationAdministrator'

          else if (emp.departmentEmployments.findIndex(x => x.isDepartmentInstructor) > -1)
            return 'isDepartmentInstructor'
        }
      } else {
        if (emp.isDistanceEducationAdministrator) return 'isDistanceEducationAdministrator'
        if (emp.isCompanyEducationResponsible) return 'isEducationResponsible'        
        if (emp.isInstructor) return 'isInstructor'
      }
    },
    getShortRoleDescription(emp, hasDep = false) {
      let roles = []
      if (emp.apprentice) roles.push('LÄR')
      if (emp.isAdministrator) {
        roles.push('FTGADM')
      }

      if (emp.departmentEmployments && hasDep == true) {

        if (emp.departmentEmployments.length > 0) {
          if ((emp.departmentEmployments.findIndex(x => x.isDepartmentAdministrator)) > -1)
            roles.push('AVDADM')

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentEducationResponsible)) > -1)
            roles.push('YUA')

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentDistanceEducationAdministrator)) > -1)
            roles.push('BG')

          else if (emp.departmentEmployments.findIndex(x => x.isDepartmentInstructor) > -1)
            roles.push('HL')
        }
      } else {
        if (emp.isInstructor) roles.push('HL')
        if (emp.isCompanyEducationResponsible) roles.push('YUA')
        if (emp.isDistanceEducationAdministrator) roles.push('BG')
      }
      return roles.join(', ')
    },
    //Check if the user has access for the departments.     
    //Arguments: emp is the object of employee
    //depId, the the department ID to check.
    //mustBeAdmin=true, the user can see the departments that the user is department administrator or administrator for.
    hasDepartmentId(emp, depId, mustBeAdmin = true) {
      let idx = emp.departmentEmployments.findIndex(x => x.departmentId == depId)
      if (idx >= 0) {
        //if (emp.departmentEmployments[idx].isDepartmentAdministrator == true || emp.departmentEmployments[idx].isDepartmentDistanceEducationAdministrator == true || emp.departmentEmployments[idx].isDepartmentEducationResponsible == true || emp.departmentEmployments[idx].isDepartmentInstructor == true        
        if (mustBeAdmin == false && (emp.departmentEmployments[idx].isDepartmentAdministrator == true || emp.departmentEmployments[idx].isDepartmentDistanceEducationAdministrator == true || emp.departmentEmployments[idx].isDepartmentEducationResponsible == true)) {
          return true
        }

        else if (mustBeAdmin == true && emp.departmentEmployments[idx].isDepartmentAdministrator == true)
          return true

      }
      return false
    },
    hasDepartmentIdForRole(emp, depId, role) {
      if (!emp || !depId || !role) return false
      const departmentEmployments = get(emp, 'departmentEmployments', [])

      let filteredDepartmentEmployments = departmentEmployments
        .filter(({ departmentId, department }) => Number(departmentId) === Number(depId) || (department && Number(department.id) === Number(depId)))

      if (!filteredDepartmentEmployments.length) return false

      return filteredDepartmentEmployments.some(employment => employment[role])
    },
    // eslint-disable-next-line complexity
    getRoleDescription(emp, hasDep = false, withShortDesc=false) {
      let roles = []
      if (emp.isAdministrator) roles.push(this.$t('roles.Administrator') + (withShortDesc ? " (FTGADM)" : ''))
      if (emp.departmentEmployments && hasDep == true) {

        if (emp.departmentEmployments.length > 0) {

          if ((emp.departmentEmployments.findIndex(x => x.isDepartmentAdministrator)) > -1)
            roles.push(this.$t('roles.avd-admin') + (withShortDesc ? " (AVDADM)" : ''))

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentEducationResponsible)) > -1)
            roles.push(this.$t('labels.yua') + (withShortDesc ? " (YUA)" : ''))

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentDistanceEducationAdministrator)) > -1)
            roles.push(this.$t('roles.DistanceEducationAdministrator') + (withShortDesc ? " (BG)" : ''))

          else if (emp.departmentEmployments.findIndex(x => x.isDepartmentInstructor) > -1)
            roles.push(this.$t('roles.Instructor') + (withShortDesc ? " (HL)" : ''))
        }
      } else {
        if (emp.apprentice) roles.push(this.$t('roles.Apprentice') + (withShortDesc ? " (LÄR)" : ''))
        if (emp.isInstructor) roles.push(this.$t('roles.Instructor') + (withShortDesc ? " (HL)" : ''))
        if (emp.isCompanyEducationResponsible) roles.push(this.$t('labels.yua') + (withShortDesc ? " (YUA)" : ''))
        if (emp.isDistanceEducationAdministrator) roles.push(this.$t('roles.DistanceEducationAdministrator') + (withShortDesc ? " (BG)" : ''))
        if (emp.isDepartmentAdministrator) roles.push(this.$t('roles.avd') + (withShortDesc ? " (AVDADM)" : ''))
      }
      return roles.join(', ')
    },

    getRoleAvatar(emp, hasDep = false) {
      let avatar = ''
      if (emp.isAdministrator) {
        avatar = '$sl-admin'
      }
      else if (emp.departmentEmployments && hasDep == true) {
        if (emp.departmentEmployments.length > 0) {
          if ((emp.departmentEmployments.findIndex(x => x.isDepartmentAdministrator)) > -1)
            avatar = '$sl-departments-admin'

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentEducationResponsible)) > -1)
            avatar = '$sl-yua'

          else if ((emp.departmentEmployments.findIndex(x => x.isDepartmentDistanceEducationAdministrator)) > -1)
            avatar = '$sl-distance-admin'

          else if (emp.departmentEmployments.findIndex(x => x.isDepartmentInstructor) > -1)
            avatar = '$sl-instructor'
        }
        else {
          avatar = ''
        }
      } else {
        if (emp.apprentice) avatar = '$sl-apprentice'
        if (emp.isInstructor) avatar = '$sl-instructor'
        if (emp.isCompanyEducationResponsible) avatar = '$sl-yua'
        if (emp.isDistanceEducationAdministrator) avatar = '$sl-distance-admin'
        if (emp.isDepartmentAdministrator) avatar = '$sl-departments-admin'
      }

      return avatar
    },
    getRoleAvatarDepartment(emp, id) {
      let avatar = ''
      if (emp.isAdministrator) {
        avatar = '$sl-admin'
      }
      else {

        let dep = emp.departmentEmployments.find(x => x.id == id)

        if (dep) {
          if (dep.isDepartmentInstructor) avatar = '$sl-instructor'
          if (dep.isDepartmentEducationResponsible) avatar = '$sl-yua'
          if (dep.isDepartmentDistanceEducationAdministrator) avatar = '$sl-distance-admin'
          if (dep.isDepartmentAdministrator) avatar = '$sl-departments-admin'
        }
      }

      return avatar
    },
    isSameDepartment(departmentEmployments, currentUserDepartmentsIds, hasDepartments=true) {
      let ret = false

      if (hasDepartments==false) {
        ret = true
      }
      else if (departmentEmployments.length>0 && currentUserDepartmentsIds.length>0) {        
  
        departmentEmployments.forEach(e => {
          if (currentUserDepartmentsIds.includes(e.department.id))
          { 
            ret = true
          }          
        });        
      }
      return ret
    },
    getdepartmentEmploymentsIds(departmentEmployments, currentUserDepartmentsIds) {
      let ids = []
      if (departmentEmployments.length>0 && currentUserDepartmentsIds.length>0) {        
        departmentEmployments.forEach(e => {
          if (currentUserDepartmentsIds.find(f => f == e.departmentId))
          {
            ids.push(e.departmentId)
          }          
        });        
      }
      return ids
    },
    //Use to get the departments Id the user has permissions for. 
    //Arguments: isAdm=true, the user can see all the departments.
    //isDepAdmin=true, the user can only see the departments that the user is department administrator for.
    //isDepAdmin=false, the user can see the departments that the user is department administrator/department distance education administrator/department education responsible for.
    getCurrentUserDepartmentsIds(compId, isAdm = true, isDepAdmin = true, isInstructor= false) {
      let ids = []
      if (this.currentUser && this.currentUser.employments && compId && compId > 0) {
        let found = this.currentUser.employments.find(x => x.companyId == compId)
        if (found && found.departmentEmployments) {
          found.departmentEmployments.forEach(e => {
            if (isAdm == true)
              ids.push(e.department.id)
            else if (isDepAdmin == true) {
              if (e.isDepartmentAdministrator == true)
                ids.push(e.department.id)
            }
            else if (e.isDepartmentAdministrator == true || e.isDepartmentDistanceEducationAdministrator == true || e.isDepartmentEducationResponsible == true)
              ids.push(e.department.id)
            else if (isInstructor==true && e.isDepartmentInstructor)
              ids.push(e.department.id)
          });
        }
      }
      return ids
    },
    //Use to get the departments name the user has permissions for. 
    //Arguments: isAdm=true, the user can see all the departments.
    //isDepAdmin=true, the user can only see the departments that the user is department administrator for.
    //isDepAdmin=false, the user can see the departments that the user is department administrator/department distance education administrator/department education responsible for.
    // eslint-disable-next-line max-params
    getCurrentUserDepartments(compId, isAdm = true, isDepAdmin = true, includeInstructor = false, includeYUA=false) {

      let deps = []
      if (this.currentUser && this.currentUser.employments && compId && compId > 0) {
        let found = this.currentUser.employments.find(x => x.companyId == compId)
        if (found && found.departmentEmployments) {

          found.departmentEmployments.forEach(e => {
            if (isAdm == true)
              deps.push(e.department.name)
            
            else if (includeInstructor == true) {
              if (e.isDepartmentInstructor == true || e.isDepartmentAdministrator == true || e.isDepartmentDistanceEducationAdministrator == true || e.isDepartmentEducationResponsible == true)
                deps.push(e.department.name)
            }
            else if (includeYUA == true) {
              if (e.isDepartmentAdministrator == true || e.isDepartmentEducationResponsible == true)
                deps.push(e.department.name)
            }
            
            else if (isDepAdmin == true) {
              if (e.isDepartmentAdministrator == true)
                deps.push(e.department.name)
            }
            
            else if (e.isDepartmentAdministrator == true || e.isDepartmentDistanceEducationAdministrator == true || e.isDepartmentEducationResponsible == true)
              deps.push(e.department.name)

          });
        }
      }
      return deps.join(', ')
    },

    hasDepartments(compId) {
      if (this.currentUser && this.currentUser.employments && compId && compId > 0) {
        let found = this.currentUser.employments.find(x => x.companyId == compId)

        if (found && found.company && found.company.hasDepartments && found.company.hasDepartments == true) {
          return true
        }

        return false
      }

      return false
    },

  }
}

export default CompanyRoles
